import { Badge } from '@/components/ui/badge'

type TrainingStatus = 'Valid' | 'DueSoon' | 'Overdue' | 'NoExpiry'

const config: Record<TrainingStatus, { label: string; variant: 'success' | 'warning' | 'danger' | 'neutral' }> = {
  Valid: { label: 'Valid', variant: 'success' },
  DueSoon: { label: 'Due Soon', variant: 'warning' },
  Overdue: { label: 'Overdue', variant: 'danger' },
  NoExpiry: { label: 'No Expiry', variant: 'neutral' },
}

export function StatusBadge({ status }: { status: string }) {
  const s = config[status as TrainingStatus] ?? { label: status, variant: 'neutral' as const }
  return <Badge variant={s.variant}>{s.label}</Badge>
}
